import { UserPlan } from "./plan";

/**
 * 当前登录人用户实体
 */
export class User {
  constructor(user) {
    if (!user) {
      return;
    }
    // 用户唯一标识
    this.id = user.id;
    // 用户邮箱
    this.email = user.email;
    // 剩余可添加unlimited 用户数量
    this.premiumPublisherRemaining = Number(user.premium_publisher_remaining);
    this.premiumInstagramRemaining = Number(user.premium_instagram_remaining);
    this.premiumFacebookRemaining = Number(user.premium_facebook_remaining);
    this.premiumTwitterRemaining = Number(user.premium_twitter_remaining);
    // 剩余可添加member 用户数量
    this.memberRemaining = Number(user.member_remaining);
    // 计算支付方式 0:从未支付 1：strip 2:paypal
    this.paymentMethod = user.subscription.payment_method;
    if (user.subscription.plan.price === 0) {
      this.paymentMethod = 0;
    }
    // link instagram
    this.linkedInstagramList = user.publiships
      .map((p) => new LinkInstagram(p))
      .filter(
        (p) =>
          p.socialNetwork === 2 ||
          p.socialNetwork === 3 ||
          p.socialNetwork === 4 ||
          p.socialNetwork === 1
      );
    this.linkedInstagramList1 = user.publiships
      .map((p) => new LinkInstagram(p))
      .filter(
        (p) =>
          p.socialNetwork === 1 ||
          p.socialNetwork === 2 ||
          p.socialNetwork === 3 ||
          p.socialNetwork === 4
      );
    // team members
    this.teamMemberList = user.memberships.map((p) => new TeamMember(p));
    // 计划
    this.plan = new UserPlan(user.subscription);
    // 信用卡号
    if (!user.credit_card) {
      this.creditCard = "**** **** **** ****";
    } else {
      this.creditCard = user.credit_card;
    }
    this.free = user.subscription.plan.price === 0;
    this.existPaypalSubscription = user.exist_paypal_subscription;
    // 用户名
    this.name = user.name;
    this.instagramNum = user.premium_instagram_remaining;
    this.facebookNum = user.premium_facebook_remaining;
    // 2020.3.24 是否存在取消订阅优惠
    if (user.limited_time_offers) {
      this.unsubscription = user.limited_time_offers.unsubscription;
    } else {
      this.unsubscription = false;
    }
  }
}

/**
 * Publisher
 */
export class Publisher {
  constructor(vo) {
    this.id = vo.id;
    // 计算总可发送autopost数量
    // 头像图片
    this.image = vo.publisher.social_profile_picture; // 头像
    this.socialNetwork = vo.publisher.social_network; // 来源 1: Instagram 2: Facebook Page 3: Facebook Group 4: tw
    // 用户名
    this.username = vo.publisher.social_username;
    // publsher唯一标示
    this.publisherId = vo.publisher.id;
    // 计算简单描述
    this.description = `${vo.autopost_remaining} schedules left`;
    // this.description = ``
    if (vo.is_premium) {
      // this.description = ''
      this.description = "Unlimited";
    }
    // 剩余可发送条数
    this.autopostRemaining = Number(vo.autopost_remaining);
    // 是否為unlimited用戶
    this.isUnlimited = vo.is_premium;
    // 是否为member用户
    this.isMember = vo.linked_as === 2;
    if (this.isMember) {
      this.description = vo.admin_email;
    }
    // 用户状态 1:有密码状态 2 无密码
    this.status = vo.publisher.status;
    // 说明其为无密码状态需要显示is me 页面
    if (this.status === 2) {
      // 描述文字也响应修改一下
      this.description = null;
    }
    // 是否为添加过的unlimited账号
    // this.wasPremium = vo.was_premium_in_current_period
    this.wasPremium = false; // 2020.1.12 去掉30天限制
    // 该publisher拥有的权限
    this.permissions = vo.premium_feature_permissions;
    // 该publisher 是否有product
    this.socialCanTagProducts = vo.publisher.social_can_tag_products;
    // ins 相关post flowing flower数量 social_follower_count social_following_count social_post_count
    this.followerCount = vo.publisher.social_follower_count;
    this.followingCount = vo.publisher.social_following_count;
    this.postCount = vo.publisher.social_post_count;
    // 查询最近ins 12张图片所需uid
    this.socialUid = vo.publisher.social_uid;
    // fb对应的access_token 用于请求接口
    this.userToken = vo.publisher.social_user_token;
    this.defaultPostTime = vo.default_post_time;
    this.defaultPostStoryTime = vo.default_post_time_story;
    this.memberId = vo.member_id;
    // 计算default caption or comment的apply on
    this.defaultCaption = {
      open: vo.is_default_caption_on,
      ...computedDefault(vo.default_caption_apply_on),
      repostContentPosition: vo.repost_content_position,
    };
    this.defaultComment = {
      open: vo.is_default_comment_on,
      ...computedDefault(vo.default_comment_apply_on),
    };
    if (this.permissions && !this.permissions.default_caption) {
      this.defaultCaption.open = this.defaultComment.open = false;
    }
    // repost 的时候caption处理的方式
    this.repostCaptionChoice = vo.repost_caption_choice;
    // repost 的时候caption处理的方式
    this.repostContentPosition = vo.repost_content_position;
    this.userToken = vo.publisher.social_user_token;
    this.pageToken = vo.publisher.social_page_token;
    this.isBusiness = vo.publisher.social_is_business;
  }
}

/**
 * 计算各类型选中
 */
function computedDefault(text) {
  let select = [...Number(text).toString(2)];
  let selectNum = select.length;
  for (let k = 0; k < 4 - selectNum; k++) {
    select.unshift("0");
  }
  if (text === null) {
    select = ["1", "1", "1", "1"];
  }
  return {
    schedule: select[3] === "1",
    drag: select[2] === "1",
    search: select[1] === "1",
    bulk: select[0] === "1",
    text: select,
  };
}

export class LinkInstagram extends Publisher {
  constructor(vo) {
    super(vo);
    // member的邮箱
    this.member = vo.admin_email;
    this.notification = new Notification(vo);
  }
}

export class TeamMember {
  constructor(teamMember) {
    this.id = teamMember.member_id;
    this.adminEmail = teamMember.admin_email;
    this.memberEmail = teamMember.member_email;
    this.publishers = teamMember.publiships.map(
      (vo) => new TeamMemberPublisher({ vo, memberId: this.id })
    );
  }
}

export class TeamMemberPublisher extends Publisher {
  constructor({ vo, memberId }) {
    super(vo);
    this.memberId = memberId;
  }
}

export class Notification {
  constructor(publisher) {
    this.emailPostStatus =
      publisher.email_notification_select.findIndex((s) => s === 2) !== -1;
    this.emailFailureAlert =
      publisher.email_notification_select.findIndex((s) => s === 3) !== -1;
    this.pushDailyAnalyticsReport =
      publisher.push_notification_select.findIndex((s) => s === 1) !== -1;
    this.pushPostStatus =
      publisher.push_notification_select.findIndex((s) => s === 2) !== -1;
    this.pushFailureAlert =
      publisher.push_notification_select.findIndex((s) => s === 3) !== -1;
  }
}
